import { render, staticRenderFns } from "./ProductsToFix.vue?vue&type=template&id=5aa61a66&"
import script from "./ProductsToFix.vue?vue&type=script&lang=js&"
export * from "./ProductsToFix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports